import { NgClass, NgIf } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { ConfigurationService } from '@sc/data-access-configuration';
import {
  AnswerChoice,
  getGlassNameKey,
  GlassUsageConfiguration,
  SinisterGlass,
} from '@sc/data-access-models';
import { TranslatorService } from '@sc/data-access-translation';
import { CarImgService } from '../../../services';

@Component({
  selector: 'sc-car-img-summary-basic',
  styleUrls: ['./car-img-summary-basic.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [CarImgService],
  imports: [NgIf, NgClass],
  template: `
    <div class="car-schema-container" aria-hidden="true">
      <svg
        aria-hidden="true"
        focusable="false"
        id="car-schema"
        viewBox="0 0 584 438"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <title></title>
        <g
          id="🤖-BtoB"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="Group">
            <g
              id="Group-2"
              transform="translate(105.690298, 354.613873)"
              fill="white"
              stroke="#9C9EB3"
              stroke-opacity="0.5"
              stroke-width="1.68818423"
            >
              <g
                id="Group-20-Copy-5"
                transform="translate(147.000000, 41.500000) scale(1, -1) translate(-147.000000, -41.500000) "
              >
                <g
                  id="Group-20-Copy"
                  transform="translate(147.055174, 41.223144) rotate(-3.000000) translate(-147.055174, -41.223144) translate(2.055174, 7.723144)"
                >
                  <path
                    *ngIf="
                      'sideWindow-precision_anotherGlass-frontConductor_right' as id
                    "
                    d="M35.0706528,5.81067418 C82.073767,1.79952231 108.055822,0.425543722 112.996881,1.77294508 C114.086903,2.07018819 114.985945,3.45399271 115.872251,5.6320589 C116.899011,8.15528547 117.820372,11.7741632 118.646467,16.4854538 C120.292395,25.8723275 121.5435,39.5450921 122.403777,57.5032256 L122.403777,57.5032256 L37.3850508,52.3636631 Z"
                    [id]="id"
                    class="customisablePath"
                    fill="white"
                    stroke-opacity="1"
                    stroke="var(--color-grey-dark)"
                    [ngClass]="{
                      hoverable: isHoverable(id),
                      selectedGlass: isSelected(id)
                    }"
                    (click)="onGlassChange($event)"
                  ></path>
                  <path
                    *ngIf="
                      'sideWindow-precision_custodeGlass-frontConductor_right' as id
                    "
                    d="M27.9703137,9.1658949 L29.0710351,50.589022 C17.0272985,49.6943142 10.4421243,49.2487651 9.31553463,49.2487651 C8.77589243,49.2487651 7.43530134,47.9558808 6.01742805,46.2374129 C4.80211622,44.7644503 3.55122278,42.8681638 2.64038845,40.7305103 C1.38374011,37.7812597 0.766457353,34.3615977 1.861056,30.9720474 C3.83475604,24.8602587 12.6136585,17.6335598 27.9703137,9.1658949 L27.9703137,9.1658949 Z"
                    [id]="id"
                    class="customisablePath"
                    stroke-opacity="1"
                    stroke="var(--color-grey-dark)"
                    fill="white"
                    [ngClass]="{
                      hoverable: isHoverable(id),
                      selectedGlass: isSelected(id)
                    }"
                    (click)="onGlassChange($event)"
                  ></path>
                  <path
                    *ngIf="
                      'sideWindow-precision_conductorGlass-frontConductor_right' as id
                    "
                    d="M145.295678,3.58399627 C179.809403,-1.51753631 219.02896,11.2291088 262.971313,41.7046318 L262.971313,41.7046318 L264.104947,64.8306246 L155.992797,57.6034847 Z"
                    [id]="id"
                    class="customisablePath"
                    stroke-opacity="1"
                    stroke="var(--color-grey-dark)"
                    fill="white"
                    [ngClass]="{
                      hoverable: isHoverable(id),
                      selectedGlass: isSelected(id)
                    }"
                    (click)="onGlassChange($event)"
                  ></path>
                  <path
                    *ngIf="
                      'sideWindow-precision_custodeFrontGlass-frontConductor_right' as id
                    "
                    d="M271.149847,45.9337864 L287.03702,55.9310454 C288.375063,57.9178197 289.086448,59.5950278 289.086448,60.9811794 C289.086448,61.5802129 288.943664,62.1140515 288.646041,62.5790065 C288.331965,63.0696648 287.853599,63.4801617 287.227282,63.8270162 C284.346637,65.4223176 278.972675,65.7619767 271.149847,64.9752841 L271.149847,64.9752841 L271.149847,45.9337864 Z"
                    [id]="id"
                    class="customisablePath"
                    stroke-opacity="1"
                    stroke="var(--color-grey-dark)"
                    [ngClass]="{
                      hoverable: isHoverable(id),
                      selectedGlass: isSelected(id)
                    }"
                    (click)="onGlassChange($event)"
                  ></path>
                </g>
              </g>
            </g>
            <g
              id="Group-2"
              transform="translate(252.690298, 41.500000) scale(1, -1) translate(-252.690298, -41.500000) translate(105.690298, 0.000000)"
              fill="white"
              stroke="#9C9EB3"
              stroke-opacity="0.5"
              stroke-width="1.68818423"
            >
              <g
                id="Group-20-Copy-5"
                transform="translate(147.000000, 41.500000) scale(1, -1) translate(-147.000000, -41.500000) "
              >
                <g
                  id="Group-20-Copy"
                  transform="translate(147.055174, 41.223144) rotate(-3.000000) translate(-147.055174, -41.223144) translate(2.055174, 7.723144)"
                >
                  <path
                    *ngIf="
                      'sideWindow-precision_anotherGlass-frontConductor_left' as id
                    "
                    d="M35.0706528,5.81067418 C82.073767,1.79952231 108.055822,0.425543722 112.996881,1.77294508 C114.086903,2.07018819 114.985945,3.45399271 115.872251,5.6320589 C116.899011,8.15528547 117.820372,11.7741632 118.646467,16.4854538 C120.292395,25.8723275 121.5435,39.5450921 122.403777,57.5032256 L122.403777,57.5032256 L37.3850508,52.3636631 Z"
                    [id]="id"
                    class="customisablePath"
                    stroke-opacity="1"
                    stroke="#9C9EB3"
                    fill="white"
                    [ngClass]="{
                      hoverable: isHoverable(id),
                      selectedGlass: isSelected(id)
                    }"
                    (click)="onGlassChange($event)"
                  ></path>
                  <path
                    *ngIf="
                      'sideWindow-precision_custodeGlass-frontConductor_left' as id
                    "
                    d="M27.9703137,9.1658949 L29.0710351,50.589022 C17.0272985,49.6943142 10.4421243,49.2487651 9.31553463,49.2487651 C8.77589243,49.2487651 7.43530134,47.9558808 6.01742805,46.2374129 C4.80211622,44.7644503 3.55122278,42.8681638 2.64038845,40.7305103 C1.38374011,37.7812597 0.766457353,34.3615977 1.861056,30.9720474 C3.83475604,24.8602587 12.6136585,17.6335598 27.9703137,9.1658949 L27.9703137,9.1658949 Z"
                    [id]="id"
                    stroke-opacity="1"
                    stroke="#9C9EB3"
                    fill="white"
                    class="customisablePath"
                    [ngClass]="{
                      hoverable: isHoverable(id),
                      selectedGlass: isSelected(id)
                    }"
                    (click)="onGlassChange($event)"
                  ></path>
                  <path
                    *ngIf="
                      'sideWindow-precision_conductorGlass-frontConductor_left' as id
                    "
                    d="M145.295678,3.58399627 C179.809403,-1.51753631 219.02896,11.2291088 262.971313,41.7046318 L262.971313,41.7046318 L264.104947,64.8306246 L155.992797,57.6034847 Z"
                    [id]="id"
                    stroke-opacity="1"
                    stroke="var(--color-grey-dark)"
                    fill="white"
                    class="customisablePath"
                    [ngClass]="{
                      hoverable: isHoverable(id),
                      selectedGlass: isSelected(id)
                    }"
                    (click)="onGlassChange($event)"
                  ></path>
                  <path
                    *ngIf="
                      'sideWindow-precision_custodeFrontGlass-frontConductor_left' as id
                    "
                    d="M271.149847,45.9337864 L287.03702,55.9310454 C288.375063,57.9178197 289.086448,59.5950278 289.086448,60.9811794 C289.086448,61.5802129 288.943664,62.1140515 288.646041,62.5790065 C288.331965,63.0696648 287.853599,63.4801617 287.227282,63.8270162 C284.346637,65.4223176 278.972675,65.7619767 271.149847,64.9752841 L271.149847,64.9752841 L271.149847,45.9337864 Z"
                    [id]="id"
                    stroke-opacity="1"
                    stroke="var(--color-grey-dark)"
                    class="customisablePath"
                    [ngClass]="{
                      hoverable: isHoverable(id),
                      selectedGlass: isSelected(id)
                    }"
                    (click)="onGlassChange($event)"
                  ></path>
                </g>
              </g>
            </g>
            <g id="Group-7" transform="translate(0.000000, 82.860000)">
              <g
                id="Schéma_car_top_select"
                transform="translate(292.449198, 135.550802) rotate(-270.000000) translate(-292.449198, -135.550802) translate(156.949198, -155.949198)"
              >
                <path
                  d="M136.335079,1.1777326 L137.504094,1.18031758 C175.62486,1.34958713 202.848365,9.80874513 219.067083,26.7514875 C235.226234,43.6320035 245.490882,62.4247632 249.842416,83.1340133 L249.842416,83.1340133 L250.000437,83.9016901 L250.000437,303.65045 L247.439543,470.925884 L231.009335,549.451438 L230.821367,549.943525 C227.19367,559.2657 220.915143,567.020598 213.042916,572.475663 C205.170764,577.930676 195.70492,581.085914 185.709641,581.208668 L185.709641,581.208668 L185.095438,581.21246 L87.5912108,581.21246 C77.471018,581.21246 67.876083,578.106375 59.8942507,572.648115 C51.9047212,567.184592 45.5313777,559.364376 41.8679097,549.950341 L41.8679097,549.950341 L41.6773096,549.451417 L25.2471055,470.925884 L22.6862121,303.65045 L22.6862121,83.8995693 C26.9456961,62.8847752 37.2628046,43.8384352 53.6195655,26.7514875 C69.8382835,9.80874513 97.0617889,1.34958713 135.179958,1.18032625 L135.179958,1.18032625 L136.335079,1.1777326 Z"
                  id="corps"
                  stroke="#9C9EB3"
                  stroke-width="1.96289247"
                  class="customisablePath"
                  fill="var(--color-grey-extra-light)"
                ></path>
                <rect
                  *ngIf="'topWindow' as id"
                  [id]="id"
                  stroke="var(--color-grey-dark)"
                  stroke-width="1.96289247"
                  fill="white"
                  x="80.7878292"
                  y="260.083252"
                  width="111.296003"
                  height="162.527496"
                  rx="6.2812559"
                  class="customisablePath"
                  [ngClass]="{
                    hoverable: isHoverable(id),
                    selectedGlass: isSelected(id)
                  }"
                  (click)="onGlassChange($event)"
                ></rect>
                <path
                  *ngIf="'rearWindow' as id"
                  d="M211.7353,442.980528 C211.894487,442.947344 212.052053,442.981827 212.178118,443.064402 L212.178118,443.064402 L218.112671,516.844891 C218.121887,516.964034 218.094637,517.080052 218.038393,517.179706 C217.982146,517.279368 217.896902,517.362665 217.790137,517.416358 C200.309585,526.207508 173.151778,530.569834 136.337686,530.569834 C99.5236118,530.569834 72.3658137,526.207512 54.8852364,517.416359 C54.7784757,517.362671 54.693237,517.27938 54.6369911,517.179726 C54.5807419,517.080065 54.5534887,516.964039 54.5627013,516.844888 L54.5627013,516.844888 L60.2327999,443.511614 C60.2453403,443.349484 60.3224079,443.207783 60.4368734,443.10975 C60.5390726,443.022222 60.6710849,442.969504 60.8181047,442.968245 C85.4996272,448.094034 110.606381,450.642975 136.337686,450.642975 C162.096064,450.642975 187.228575,448.088629 211.7353,442.980528 Z"
                  [id]="id"
                  stroke="var(--color-grey-dark)"
                  stroke-width="1.96289247"
                  fill="white"
                  class="customisablePath"
                  [ngClass]="{
                    hoverable: isHoverable(id),
                    selectedGlass: isSelected(id)
                  }"
                  (click)="onGlassChange($event)"
                ></path>
                <path
                  *ngIf="'windshield' as id"
                  d="M135.454384,131.710085 C177.14515,131.710085 208.825266,142.502879 230.445057,164.189472 C230.584414,164.329262 230.644469,164.529575 230.604999,164.722976 L230.604999,164.722976 L215.414209,239.157848 C188.224258,231.671552 161.839226,227.715073 135.454384,227.715073 C109.063712,227.715073 82.6728651,231.673346 56.2821249,239.59171 L56.2821249,239.59171 L42.2412443,164.696291 C42.2085663,164.513313 42.2642043,164.325651 42.3913254,164.190047 C62.7274837,142.496834 93.7693446,131.710085 135.454384,131.710085 Z"
                  [id]="id"
                  stroke="var(--color-grey-dark)"
                  stroke-width="1.96289247"
                  fill="white"
                  class="customisablePath"
                  [ngClass]="{
                    hoverable: isHoverable(id),
                    selectedGlass: isSelected(id)
                  }"
                  (click)="onGlassChange($event)"
                ></path>
                <path
                  d="M36.1798877,208.331141 C36.3320528,208.460038 36.4850589,208.609349 36.6401381,208.774402 C37.3957471,209.578609 38.147847,210.784313 38.9034089,212.360637 C40.4815365,215.653077 42.0276737,220.49847 43.452279,226.76082 C46.0733028,238.282445 48.2623577,254.5498 49.398684,274.768097 C50.1888357,288.827018 50.5935364,299.795325 50.6062463,307.672219 L50.6060775,308.519253 C50.5951562,313.806132 50.3970024,317.617295 50.0094592,319.952479 C49.9999265,320.009919 49.9791597,320.064916 49.9483474,320.114321 C49.883634,320.218084 49.7829881,320.285792 49.6725804,320.311384 C49.5621656,320.336977 49.4419873,320.320448 49.33824,320.255748 L49.33824,320.255748 L36.3883936,312.179381 Z"
                  id="Path-2"
                  stroke="var(--color-grey-dark)"
                  stroke-width="1.96289247"
                  fill="var(--color-grey-main)"
                  class="customisablePath"
                ></path>
                <path
                  d="M220.102912,208.331141 C220.255077,208.460038 220.408083,208.609349 220.563162,208.774402 C221.318771,209.578609 222.070871,210.784313 222.826433,212.360637 C224.404561,215.653077 225.950698,220.49847 227.375303,226.76082 C229.996327,238.282445 232.185382,254.5498 233.321708,274.768097 C234.11186,288.827018 234.516561,299.795325 234.529271,307.672219 L234.529102,308.519253 C234.518181,313.806132 234.320027,317.617295 233.932484,319.952479 C233.922951,320.009919 233.902184,320.064916 233.871372,320.114321 C233.806658,320.218084 233.706012,320.285792 233.595605,320.311384 C233.48519,320.336977 233.365012,320.320448 233.261264,320.255748 L233.261264,320.255748 L220.311418,312.179381 Z"
                  id="Path-2-Copy"
                  stroke="var(--color-grey-dark)"
                  stroke-width="1.96289247"
                  fill="var(--color-grey-main)"
                  class="customisablePath"
                  transform="translate(227.313403, 264.508408) scale(-1, 1) translate(-227.313403, -264.508408) "
                ></path>
                <path
                  d="M36.3604571,327.048248 C36.7388147,326.909772 36.806537,326.924011 36.8684034,326.952953 L36.8684034,326.952953 L46.790244,331.594478 C46.8681018,331.630901 46.9319031,331.688207 46.97624,331.757897 C47.0205769,331.827586 47.0454493,331.90966 47.0454493,331.995616 L47.0454493,331.995616 L47.0454493,410.272007 C47.0454493,410.424651 46.9668396,410.566535 46.8374234,410.647477 L46.8374234,410.647477 L38.9428526,415.585071 C38.8391692,415.649919 38.7190167,415.666602 38.6085731,415.641152 C38.4981294,415.615702 38.3973947,415.548119 38.3325468,415.444436 C38.2903489,415.376967 38.2671103,415.299374 38.2652745,415.219817 L38.2652745,415.219817 L36.2380047,327.364307 C36.2351836,327.242047 36.2821852,327.130217 36.3604571,327.048248 Z"
                  id="Path-3"
                  stroke="var(--color-grey-dark)"
                  stroke-width="1.96289247"
                  fill="var(--color-grey-main)"
                  class="customisablePath"
                ></path>
                <path
                  d="M223.816688,327.048248 C224.195045,326.909772 224.262768,326.924011 224.324634,326.952953 L224.324634,326.952953 L234.246475,331.594478 C234.324333,331.630901 234.388134,331.688207 234.432471,331.757897 C234.476808,331.827586 234.50168,331.90966 234.50168,331.995616 L234.50168,331.995616 L234.50168,410.272007 C234.50168,410.424651 234.42307,410.566535 234.293654,410.647477 L234.293654,410.647477 L226.399083,415.585071 C226.2954,415.649919 226.175248,415.666602 226.064804,415.641152 C225.95436,415.615702 225.853625,415.548119 225.788778,415.444436 C225.74658,415.376967 225.723341,415.299374 225.721505,415.219817 L225.721505,415.219817 L223.694236,327.364307 C223.691414,327.242047 223.738416,327.130217 223.816688,327.048248 Z"
                  id="Path-3-Copy"
                  stroke="var(--color-grey-dark)"
                  stroke-width="1.96289247"
                  fill="var(--color-grey-main)"
                  class="customisablePath"
                  transform="translate(229.068899, 371.431268) scale(-1, 1) translate(-229.068899, -371.431268) "
                ></path>
                <path
                  d="M43.2462501,422.847282 L41.220691,440.661001 L38.7911729,425.628222 L43.2462501,422.847282 Z"
                  id="Path-4"
                  stroke="var(--color-grey-dark)"
                  stroke-width="1.96289247"
                  fill="var(--color-grey-main)"
                  class="customisablePath"
                ></path>
                <path
                  d="M230.983469,422.894018 L228.95791,440.707737 L226.528392,425.674959 L230.983469,422.894018 Z"
                  id="Path-4-Copy"
                  stroke="var(--color-grey-dark)"
                  stroke-width="1.96289247"
                  fill="var(--color-grey-main)"
                  class="customisablePath"
                  transform="translate(228.997757, 435.255152) scale(-1, 1) translate(-228.997757, -435.255152) "
                ></path>
                <path
                  *ngIf="'lights-lightsEmplacement_rear-lateral_left' as id"
                  d="M48.3018327,551.793629 C48.4818131,551.789376 48.6634152,551.853785 48.8040098,551.987898 C52.4538275,555.46913 57.9870614,558.992646 65.4182801,562.538953 C74.6783287,566.95801 82.1465041,569.263457 87.8139259,569.502691 L87.8139259,569.502691 L87.8139349,577.815153 C70.1993781,575.439398 56.7886714,568.39183 47.6149598,556.618841 L47.6149598,556.618841 L47.6149464,552.496951 C47.6149464,552.316121 47.6845766,552.142234 47.8093852,552.011382 C47.9434693,551.870804 48.1218396,551.797882 48.3018327,551.793629 Z"
                  [id]="id"
                  stroke="var(--color-grey-dark)"
                  stroke-width="1.96289247"
                  class="customisablePath"
                  fill="white"
                  [ngClass]="{
                    hoverable: isHoverable(id),
                    selectedGlass: isSelected(id)
                  }"
                  (click)="onGlassChange($event)"
                ></path>
                <path
                  *ngIf="'lights-lightsEmplacement_rear-lateral_right' as id"
                  d="M183.545124,551.793629 C183.725104,551.789376 183.906706,551.853785 184.047301,551.987898 C187.697119,555.46913 193.230352,558.992646 200.661571,562.538953 C209.92162,566.95801 217.389795,569.263457 223.057217,569.502691 L223.057217,569.502691 L223.057226,577.815153 C205.442669,575.439398 192.031963,568.39183 182.858251,556.618841 L182.858251,556.618841 L182.858238,552.496951 C182.858238,552.316121 182.927868,552.142234 183.052676,552.011382 C183.18676,551.870804 183.365131,551.797882 183.545124,551.793629 Z"
                  [id]="id"
                  stroke="var(--color-grey-dark)"
                  stroke-width="1.96289247"
                  fill="white"
                  class="customisablePath"
                  transform="translate(202.957732, 563.485305) scale(-1, 1) translate(-202.957732, -563.485305) "
                  [ngClass]="{
                    hoverable: isHoverable(id),
                    selectedGlass: isSelected(id)
                  }"
                  (click)="onGlassChange($event)"
                ></path>
                <path
                  d="M136.337686,7.65528063 C164.675904,7.65528063 187.052505,11.4804892 203.454053,19.1797383 C219.641796,26.7786224 229.962026,38.1613144 234.366505,53.3667618 C234.448956,53.651408 234.493643,53.9456555 234.499415,54.2419464 L234.499415,54.2419464 L236.287087,146.003047 C236.305277,146.936882 235.943235,147.789685 235.343186,148.413578 C234.743138,149.037469 233.905085,149.43245 232.971251,149.450643 C232.182334,149.466013 231.41287,149.205073 230.79604,148.712989 C211.549857,133.359101 180.086823,125.607491 136.337686,125.607491 C92.5885461,125.607491 61.1255108,133.359102 41.8793315,148.71299 C41.1491926,149.295463 40.2520815,149.526849 39.3918862,149.430081 C38.5316924,149.333314 37.7084143,148.908395 37.1259392,148.178259 C36.6338551,147.561429 36.3729157,146.791965 36.3882853,146.003049 L36.3882853,146.003049 L38.1759573,54.241947 C38.181727,53.9456598 38.2264128,53.6514161 38.3088635,53.3667738 C42.7133414,38.1613211 53.0335704,26.7786266 69.2213136,19.1797408 C85.6228621,11.48049 107.999465,7.65528063 136.337686,7.65528063 Z"
                  id="capot"
                  stroke="var(--color-grey-main)"
                  stroke-width="2.25490612"
                  class="customisablePath"
                  fill="var(--color-grey-extra-light)"
                  transform="translate(136.337686, 81.608465) scale(-1, 1) translate(-136.337686, -81.608465) "
                ></path>
                <path
                  d="M36.0784979,315.497067 L49.6079346,324.194562 L49.6079346,328.63392 L36.0784979,322.83559 L36.0784979,315.497067 Z"
                  id="Rectangle"
                  stroke="var(--color-grey-dark)"
                  stroke-width="1.96289247"
                  fill="var(--color-grey-main)"
                  class="customisablePath"
                ></path>
                <path
                  d="M220.9808,315.497067 L234.510236,324.194562 L234.510236,328.63392 L220.9808,322.83559 L220.9808,315.497067 Z"
                  id="Rectangle-Copy"
                  stroke="var(--color-grey-dark)"
                  stroke-width="1.96289247"
                  fill="var(--color-grey-main)"
                  class="customisablePath"
                  transform="translate(227.745518, 321.887848) scale(-1, 1) translate(-227.745518, -321.887848) "
                ></path>
                <path
                  *ngIf="'mirror-mirror_left' as id"
                  d="M35.1023313,176.29991 L38.5996265,203.449389 C36.5103976,201.475207 34.1277001,200.77274 31.4646425,201.296871 C30.457638,201.495064 29.6279536,201.904027 28.9656416,202.504855 C28.3092426,203.100318 27.812333,203.889839 27.4948842,204.886881 C26.9843668,206.490313 26.9463135,208.68485 27.4384098,211.477756 L27.4384098,211.477756 L1.18954051,224.202623 C0.400295899,219.940644 1.8565624,214.987636 5.00129406,210.524734 C8.29553002,205.84966 13.4594643,201.702548 19.9915619,199.374559 C24.7598974,197.675161 28.4010071,194.863505 30.9275092,190.955072 C33.3951641,187.137673 34.7990519,182.257063 35.1023313,176.29991 L35.1023313,176.29991 Z"
                  [id]="id"
                  stroke="#9C9EB3"
                  stroke-width="1.96289247"
                  fill="white"
                  class="customisablePath"
                  [ngClass]="{
                    hoverable: isHoverable(id),
                    selectedGlass: isSelected(id)
                  }"
                  (click)="onGlassChange($event)"
                ></path>
                <path
                  *ngIf="'mirror-mirror_right' as id"
                  d="M265.658856,176.29991 L269.156151,203.449389 C267.066922,201.475207 264.684225,200.77274 262.021167,201.296871 C261.014163,201.495064 260.184478,201.904027 259.522166,202.504855 C258.865767,203.100318 258.368858,203.889839 258.051409,204.886881 C257.540891,206.490313 257.502838,208.68485 257.994934,211.477756 L257.994934,211.477756 L231.746065,224.202623 C230.95682,219.940644 232.413087,214.987636 235.557819,210.524734 C238.852055,205.84966 244.015989,201.702548 250.548086,199.374559 C255.316422,197.675161 258.957532,194.863505 261.484034,190.955072 C263.951689,187.137673 265.355576,182.257063 265.658856,176.29991 L265.658856,176.29991 Z"
                  [id]="id"
                  stroke="#9C9EB3"
                  class="customisablePath"
                  stroke-width="1.96289247"
                  fill="white"
                  transform="translate(250.536357, 200.468695) scale(-1, 1) translate(-250.536357, -200.468695) "
                  [ngClass]="{
                    hoverable: isHoverable(id),
                    selectedGlass: isSelected(id)
                  }"
                  (click)="onGlassChange($event)"
                ></path>
                <path
                  *ngIf="'lights-lightsEmplacement_front-lateral_left' as id"
                  d="M52.718,7.936 L52.7294686,7.94821123 C56.3253941,11.6600348 62.0470657,15.4305048 70.0039238,19.2243944 C79.0039303,23.515665 86.2655316,25.7568253 91.780027,25.9958502 L91.780027,25.9958502 L91.780027,34.0198297 C74.6669777,31.7077745 61.6354283,24.8638372 52.7184669,13.4345141 L52.7184669,13.4345141 L52.718,7.936 Z"
                  [id]="id"
                  stroke="#9C9EB3"
                  stroke-width="1.96289247"
                  fill="white"
                  class="customisablePath"
                  transform="translate(72.249247, 20.119648) scale(1, -1) translate(-72.249247, -20.119648) "
                  [ngClass]="{
                    hoverable: isHoverable(id),
                    selectedGlass: isSelected(id)
                  }"
                  (click)="onGlassChange($event)"
                ></path>
                <path
                  *ngIf="'lights-lightsEmplacement_front-lateral_right' as id"
                  d="M178.932,7.936 L178.943454,7.94821123 C182.53938,11.6600348 188.261051,15.4305048 196.21791,19.2243944 C205.217916,23.515665 212.479517,25.7568253 217.994013,25.9958502 L217.994013,25.9958502 L217.994013,34.0198297 C200.880963,31.7077745 187.849414,24.8638372 178.932453,13.4345141 L178.932453,13.4345141 L178.932,7.936 Z"
                  [id]="id"
                  stroke="#9C9EB3"
                  stroke-width="1.96289247"
                  fill="white"
                  class="customisablePath"
                  transform="translate(198.463233, 20.119648) scale(-1, -1) translate(-198.463233, -20.119648) "
                  [ngClass]="{
                    hoverable: isHoverable(id),
                    selectedGlass: isSelected(id)
                  }"
                  (click)="onGlassChange($event)"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>

      <div
        class="sc-conf-display-car-img-summary-description sc-design-text-3"
        [innerHTML]="getDescriptionText()"
      ></div>
    </div>
  `,
})
export class CarImgSummaryComponentBasic {
  @Input() glasses: SinisterGlass[];
  @Input() editMode = false;

  @Output() glassChangeEvent = new EventEmitter<AnswerChoice>();

  glassUsageConfiguration: GlassUsageConfiguration;

  constructor(
    private readonly configuration: ConfigurationService,
    private readonly carImgService: CarImgService,
    private readonly translateService: TranslatorService
  ) {
    this.glassUsageConfiguration = this.configuration.getGlassUsage();
  }

  isHoverable(id: string): boolean {
    return this.editMode && !!this.carImgService.getAnswerById(id);
  }

  isSelected(id: string): boolean {
    const answersToCheck = this.carImgService.getAnswerById(id);
    if (!answersToCheck) {
      return false;
    }
    return !!this.glasses.find((sinisterGlassSelected) => {
      if (sinisterGlassSelected?.glass === 'multiple') {
        return false;
      }

      if (
        !sinisterGlassSelected?.glass ||
        sinisterGlassSelected.glass !== answersToCheck.glass ||
        ((!!sinisterGlassSelected.glassExtended ||
          !!answersToCheck.glassExtended) &&
          sinisterGlassSelected.glassExtended !== answersToCheck.glassExtended)
      ) {
        return false;
      }

      let subGlass: string;
      switch (sinisterGlassSelected.glass) {
        case 'windshield':
        case 'rearWindow':
        case 'topWindow':
          return true;
        case 'sideWindow':
          subGlass = 'lateralPrecisions';
          break;
        case 'lights':
          subGlass = 'light';
          break;
        case 'mirror':
          return (
            !sinisterGlassSelected?.mirror ||
            sinisterGlassSelected.mirror === answersToCheck.sub?.mirror ||
            sinisterGlassSelected.mirror === 'both'
          );
        default:
          break;
      }
      return Object.keys(sinisterGlassSelected?.[subGlass] || {}).reduce(
        (result, key) =>
          result &&
          (sinisterGlassSelected[subGlass][key] === null ||
            sinisterGlassSelected[subGlass][key] === undefined ||
            sinisterGlassSelected[subGlass][key] ===
              answersToCheck.sub?.[key] ||
            sinisterGlassSelected[subGlass][key] === 'both'),
        true
      );
    });
  }

  onGlassChange($event) {
    if (!this.editMode) {
      return;
    }

    const answers = this.carImgService.getAnswerById($event.target.id);
    if (answers) {
      this.glassChangeEvent.emit(answers);
    }
  }

  getDescriptionText() {
    let description = '';
    if (!this.glasses.length) {
      description = this.translateService.getInstantTranslation(
        'CarImgSummaryBasic.descriptionWithoutGlass'
      );
    } else {
      description = this.translateService.getInstantTranslation(
        'CarImgSummaryBasic.descriptionWithGlass',
        {
          glassName: this.glasses
            .map((glass) => this.getGlassName(glass))
            ?.join(', '),
        }
      );
    }
    return description;
  }

  getGlassName(glass: SinisterGlass): string {
    return this.translateService.getInstantTranslation(getGlassNameKey(glass));
  }
}
